import { render, staticRenderFns } from "./OrderInformation.vue?vue&type=template&id=c6217ad6&scoped=true&"
import script from "./OrderInformation.vue?vue&type=script&lang=js&"
export * from "./OrderInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrderInformation.vue?vue&type=style&index=0&id=c6217ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6217ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6217ad6')) {
      api.createRecord('c6217ad6', component.options)
    } else {
      api.reload('c6217ad6', component.options)
    }
    module.hot.accept("./OrderInformation.vue?vue&type=template&id=c6217ad6&scoped=true&", function () {
      api.rerender('c6217ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/OrderInformation.vue"
export default component.exports